// App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import Home from './pages/Home';
import FriendsPage from './pages/FriendsPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import EditButton from './components/ProfileData';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/editprofile" element={<EditButton />} />

        <Route path="/profile/:username" element={<Profile />} />


          <Route path="/home" element={<Home />} />
          <Route path="/friends/:firstName" element={<FriendsPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
